import { createContext } from 'react'

export interface ITabContext {
  setCurrentTab: (tabId: IdType) => void
  currentTab?: IdType
}

export const TabContext = createContext<ITabContext>({
  setCurrentTab: () => {}
})
